import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Unsplash brand icon
 * Source: Font Awesome Free 7.1.0
 */
export function UnsplashIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 640 640">
      <path d="M544 294.2L544 544L96 544L96 294.2L237.1 294.2L237.1 419.1L402.8 419.1L402.8 294.2L543.9 294.2zM402.9 96L237.2 96L237.2 220.9L402.9 220.9L402.9 96z"/>
    </SvgIcon>
  );
}
